import { render } from "./CreateSizeModal.vue?vue&type=template&id=c738a252"
import script from "./CreateSizeModal.vue?vue&type=script&lang=js"
export * from "./CreateSizeModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__